import * as React from 'react';
import { Button } from 'reactstrap';
import { FaSyncAlt } from 'react-icons/fa';
import { LayoutStoreInstance } from '../LayoutStore';

export interface IIndicatorButtonProps {
  onClick?: React.MouseEventHandler<any>;
  size?: any;
  id?: string;
  style?: React.CSSProperties;
  color?: string;
  disabled?: boolean;
  isLoading?: boolean;
  textColor?: string;
  children?: React.ReactNode;
}

export interface IIndicatorButtonState {
  showIndicator: boolean;
  forceDisable: boolean;
}

export class IndicatorButton extends React.Component<
  IIndicatorButtonProps,
  IIndicatorButtonState
> {
  constructor(props: IIndicatorButtonProps, state: IIndicatorButtonState) {
    super(props, state);
    this.state = {
      showIndicator: LayoutStoreInstance.isStoring(),
      forceDisable: LayoutStoreInstance.isLoading(),
    };
  }

  public componentDidMount() {
    LayoutStoreInstance.onStoringIsEnabledChanged.push(this.setStoring);
    LayoutStoreInstance.onLoadingIsEnabledChanged.push(this.setLoading);
    this.setState({
      showIndicator: LayoutStoreInstance.isStoring(),
      forceDisable: LayoutStoreInstance.isLoading(),
    });
  }

  public componentWillUnmount() {
    var handlerIndex = LayoutStoreInstance.onStoringIsEnabledChanged.indexOf(
      this.setStoring,
    );
    LayoutStoreInstance.onStoringIsEnabledChanged.splice(handlerIndex, 1);

    var handlerIndex = LayoutStoreInstance.onLoadingIsEnabledChanged.indexOf(
      this.setLoading,
    );
    LayoutStoreInstance.onLoadingIsEnabledChanged.splice(handlerIndex, 1);
  }

  public componentWillUpdate(newProps: IIndicatorButtonProps) {
    if (newProps.isLoading != this.props.isLoading) {
      this.setState({ showIndicator: !!newProps.isLoading });
    }
  }

  private setStoring = (isLoading: boolean) => {
    this.setState({ showIndicator: isLoading });
  };

  private setLoading = (isLoading: boolean) => {
    this.setState({ forceDisable: isLoading });
  };

  public render() {
    const { isLoading, ...propsWithoutLoading } = this.props;
    return (
      <Button
        {...propsWithoutLoading}
        disabled={
          this.state.showIndicator ||
          this.state.forceDisable ||
          this.props.disabled
        }
        children={
          this.state.showIndicator &&
          (this.props.isLoading == undefined || this.props.isLoading)
            ? [
                <FaSyncAlt
                  key="spinner-icon"
                  className="fa-spinner-animation"
                  color={this.props.textColor || 'white'}
                  style={{ marginBottom: '-0.15em', marginRight: '0.4em' }}
                />,
                this.props.children,
              ]
            : this.props.children
        }
      />
    );
  }
}
